import logger from '@/tools/logger';

export async function analyticsInitialize({ state }) {
	if (state.isPreview) return; // do not track the preview frame in the CMS
	window._paq = [];
	const g = document.createElement('script');
	const s = document.getElementsByTagName('script')[0];
	const host =
		state.isDevServer || window.location.host.indexOf('staging') !== -1
			? 'athena.staging.shoutrlabs.com'
			: 'athena.cms.shoutrlabs.com';
	const u = `https://${host}/`;
	/* tracker methods like "setCustomDimension" should be called before "trackPageView" */
	// Set configuration here
	window._paq.push(['setTrackerUrl', `${u}etna/`]);
	window._paq.push(['enableLinkTracking']);

	g.type = 'text/javascript';
	g.async = true;
	g.defer = true;
	g.src = `${u}athena.js`;
	s.parentNode.insertBefore(g, s);
}

export function analyticsLog({ state }, { exhibitionID, articleID }) {
	if (state.isPreview) return; // do not track the preview frame in the CMS
	const exhibition = state.dataSourceCFG.exhibitionMap[exhibitionID];
	if (window._paq) {
		// Set a new site id for the Matomo analytics if Matomo is loaded and a site id is available.
		const { analyticsForOrganisation, analyticsSiteId } = state.dataSourceCFG.global;
		const siteId = analyticsForOrganisation ? analyticsSiteId : exhibition.analyticsSiteId;
		if (!siteId) {
			logger.warn('Matomo site id not found. Can not track user activity.');
			return;
		}
		window._paq.push(['setSiteId', siteId]);
		const _name = exhibition.articleMap[articleID].name || articleID;
		window._paq.push(['setDocumentTitle', _name]);
		window._paq.push(['trackPageView']);
	}
}
